export default "__VITE_ASSET__BOIFnJgS__"